import { useState, useMemo } from "react"
import { Table } from "components/ui/tables/Table/Table"
import { H3 } from "components/ui/typography/titles/Titles"
import { useObjectCategoryDrawerStore } from "store/configuration.store"
import { ModelNumbersColumns } from "./ModelNumbersColumns"
import { DetachModelNumberModal } from "./layout/DetachModelNumberModal/DetachModelNumberModal"
import { LinkModelNumberModal } from "./layout/LinkModelNumberModal/LinkModelNumberModal"
import style from "./ModelNumbers.module.scss"
import { PlusIcon } from "components/ui/icons/plus/PlusIcon"

const { customBorderedTable, modelNumnersStyle, topBlock, addModelNumberButton } = style

export type TModelNumberRow = {
	key: string
	modelNumber: string
	width: string
	height: string
	depth: string
}

export const ModelNumbers = () => {
	const { objectCategoryStore, modelNumberToId } = useObjectCategoryDrawerStore()

	const [isLinkModalOpen, setIsLinkModalOpen] = useState(false)

	const [detachModal, setDetachModal] = useState<{
		isOpen: boolean
		modelNumberId?: number
		modelNumberName?: string
	}>({ isOpen: false })

	const handleDetach = (modelNumberId: number, modelNumberName: string) => {
		setDetachModal({ isOpen: true, modelNumberId, modelNumberName })
	}

	const handleDetachCancel = () => {
		setDetachModal({ isOpen: false })
	}

	const columns = ModelNumbersColumns({ modelNumberToId, onDetach: handleDetach })

	const dataSource = useMemo<TModelNumberRow[]>(() => {
		const dimensions = objectCategoryStore.dimensions || {}
		return Object.entries(dimensions).map(([modelNumber, dim]) => {
			const d = dim as unknown as Record<string, unknown>
			const formatDimension = (value: unknown) => (Array.isArray(value) ? value.join(", ") : "")

			return {
				key: modelNumber,
				modelNumber,
				width: formatDimension(d?.width),
				height: formatDimension(d?.height),
				depth: formatDimension(d?.depth),
			}
		})
	}, [objectCategoryStore.dimensions])

	return (
		<div className={modelNumnersStyle}>
			<div className={topBlock}>
				<H3>Model numbers</H3>
				<button className={addModelNumberButton} onClick={() => setIsLinkModalOpen(true)}>
					<PlusIcon />
					<span>Link model number</span>
				</button>
			</div>
			<div className={customBorderedTable}>
				<Table<TModelNumberRow> data={dataSource} columns={columns} pagination={false} bordered />
			</div>
			<DetachModelNumberModal
				isModalOpen={detachModal.isOpen}
				modelNumberId={detachModal.modelNumberId}
				modelNumberName={detachModal.modelNumberName}
				onCancel={handleDetachCancel}
			/>
			<LinkModelNumberModal isModalOpen={isLinkModalOpen} onCancel={() => setIsLinkModalOpen(false)} />
		</div>
	)
}
